<template>
    <b-overlay :show="confirming" opacity="0.5">
        <div class="table-responsive mb-0">
            <b-modal id="edit" :title="editing ? 'Düzenle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <levy-payment-update v-model="editData" :editing="editing"/>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
            
    
            <b-modal id="p-logs" size="lg" title="Düzenleme Geçmişi" body-class="p-0" no-close-on-esc hide-footer no-close-on-backdrop>
                <levy-payment-change-log v-model="logs"/>
            </b-modal>
            <button class="btn btn-primary m-50" v-on:click="addNew">Yeni Kayıt</button>
            <table class="table table-sm bordered-header">
                <thead>
                    <tr>
                        <th>İşlemler</th>
                        <th class="w-33">Ödeme Tarihi</th>
                        <th class="w-33">Ödeme Dönemi</th>
                        <th class="w-34">Ödeme Miktarı</th>
                        <th class="text-nowrap">Ödeme Onaylandı</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(p,i) in ($safe(levy,'Payments') || [])">
                        <tr :key="i">
                            <td class="d-flex g-25 justify-content-start">
                                <button v-if="$safe(p,'PaymentConfirmed') != true" v-b-tooltip.noninteractive.hover.bottom="'Onayla'" v-on:click="confirm(p)" class="btn btn-sm btn-icon btn-flat-primary">
                                    <feather-icon icon="CheckCircleIcon"></feather-icon>
                                </button>
                                <button v-if="$safe(p,'PaymentConfirmed') != true" v-b-tooltip.noninteractive.hover.bottom="'Düzenle'" v-on:click="edit(p)" class="btn btn-sm btn-icon btn-flat-secondary">
                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                </button>
                                <button v-if="$safe(p,'Manual') == true" v-b-tooltip.noninteractive.hover.bottom="'Sil'" v-on:click="del(p)" class="btn btn-sm btn-icon btn-flat-danger">
                                    <feather-icon icon="TrashIcon"></feather-icon>
                                </button>
                                <button v-b-tooltip.noninteractive.hover.bottom="'Düzenleme Geçmişi'" v-on:click="log(p)" class="btn btn-sm btn-icon btn-flat-info">
                                    <feather-icon icon="ClockIcon"></feather-icon>
                                </button>
                            </td>
                            <td>{{ $safe(p,'PaidDate') || '-' }}</td>
                            <td>{{ $safe(p,'ScoreMonthYear') || '-' }}</td>
                            <td>{{ $safe(p,'PaidAmountString') || '-' }}</td>
                            <td>
                                <div class="d-flex justify-content-center">
                                    <span class="material-icons-outlined d-block text-success" v-if="$safe(p,'PaymentConfirmed')">check_circle</span>
                                    <span class="material-icons-outlined d-block text-danger" v-else>cancel</span>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-if="($safe(levy,'Payments') || []). length == 0">
                        <tr>
                            <td colspan="100" class="text-center">Henüz bir ödeme kaydı bulunmamaktadır.</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </b-overlay>
</template>

<script>
import LevyPaymentUpdate from './LevyPaymentUpdate.vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import LevyPaymentChangeLog from './LevyPaymentChangeLog.vue';
import { VBTooltip, BOverlay } from 'bootstrap-vue';

export default {
    components:{
        LevyPaymentUpdate,
        LevyPaymentChangeLog,
        BOverlay
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    props:{
        levy:{
            type:Object,
            default: () => ({})
        }
    },
    data(){
        return {
            editData:{
                Id:null,
                Description:null,
                Period:null,
                PaidAmount:null,
                PaidDate:null,
                PaymentConfirmed:null,
                EmployeeLevyId:null
            },
            editing:false,
            confirming:false,
            loading:false,
            logs:{ logs:[] }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.editData.Id = null
            this.editData.Description = null
            this.editData.Period = null
            this.editData.PaidAmount = null
            this.editData.PaidDate = null
            this.editData.PaymentConfirmed = null
            this.editData.EmployeeLevyId = null
        },
        edit(d){
            this.clearForm()
            this.editing = true
            this.editData.Id = d.Id || null
            this.editData.Description = d.Description || null
            this.editData.Period = d.ScoreMonthYear || null
            this.editData.PaidAmount = d.PaidAmount || null
            this.editData.PaidDate = d.PaidDate || null
            this.editData.PaymentConfirmed = d.PaymentConfirmed || false
            this.editData.EmployeeLevyId = this.levy.Id || null
            this.$showModal('edit')
        },
        addNew(){
            this.clearForm()
            this.editData.EmployeeLevyId = this.levy.Id || null
            this.$showModal('edit')
        },
        confirm(item){
            this.$confirm(
                'İşleme devam etmek istediğinize emin misiniz?',
                `Bu işlem ${this.$safe(this.levy,'Employee.FullName')} isimli personelin ${item.PaidDate} tarihli icra ödemesini onaylayacaktır.`
            ).then(res => {
                if(res){
                    this.confirming = true
                    EmployeeOperationsApi.Levy.Confirm(item.Id).then(res => {
                        if(res.data.Success){
                            this.confirming = false
                            this.$emit('refresh')
                        }
                        this.$result(res)
                    }).catch(err => {
                        this.confirming = false
                        this.$result(null,err)
                    })
                }
            })
        },
        createOrUpdate(){
            this.loading = true
            EmployeeOperationsApi.Levy.Payment.CreateOrUpdate(this.editing,this.editData).then(res => {
                if(res.data.Success){
                    this.$emit('refresh')
                    this.$hideModal('edit')
                }
                this.loading = false
                this.$result(res)
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        },
        del(d){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${this.levy.Employee?.FullName} personeline ait icra ödemesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.Levy.Payment.Delete(d.Id).then(res=>{
                        if(res.data.Success) {
                            this.$emit('refresh')
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        log(d){
            this.logs = { logs: d.ChangeLogs || [] }
            this.$showModal('p-logs')
        }
    }
}
</script>